import React from 'react';
import Select, { components } from 'react-select';
import ListGridView from "./DocumentViewGallery";

const { ValueContainer, Placeholder } = components;

const CustomValueContainer = ({ children, ...props }) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(children, child =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};

const DocumentGalleryt = ({customerDetails,documentList}) => {

  return (
    <div className="doument-gallery-tabs">
      <ListGridView customerDetails={customerDetails} documentList={documentList}/>
    </div>
    
  );
};

export default DocumentGalleryt;
